import {
  AbsoluteCenter,
  Box,
  Flex,
  Grid,
  GridItem,
  Image,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { COMMON_WEB_PATH } from "../../constant";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { FireworksRight } from "../NewYearDecorations/components/Fireworks";

const leftMenu = [
  {
    label: "SLOT",
    link: "/slots",
  },
  {
    label: "LIVE",
    link: "/live-casino",
  },
  // {
  //   label: "BINGO",
  //   link: "/bingo",
  // },
];

const rightMenu = [
  {
    label: "FH",
    link: "/fish",
  },
  {
    label: "TABLE",
    link: "/table",
  },
  {
    label: "BLOCKCHAIN",
    link: "/block-chain",
  },
];

const MachineFooter = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const i18n_header = (key) => t(`header.${key}`);

  return (
    <Box
      position="fixed"
      bottom="0"
      left="0"
      w="100%"
      bgImage={`url(${COMMON_WEB_PATH}/theOne/footer/footer_machine_background.png)`}
      bgSize="100% 100%"
      bgPos="center"
      h="110px"
      zIndex="9998"
      display="flex"
    >
      <Grid pb="20px" pl="50px" w="40%" templateColumns={`repeat(2, 1fr)`}>
        {leftMenu.map((item, index) => {
          return (
            <GridItem
              role="group"
              alignItems={"center"}
              justifyContent={"flex-end"}
              display="flex"
              flexDirection={"column"}
              gap="10px"
              position="relative"
              cursor="pointer"
              as={NavLink}
              to={item.link}
              _hover={{
                _after: {
                  content: "''",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                  bgImage: `url(${COMMON_WEB_PATH}/theOne/footer/footer_menu_active.png)`,
                  bgSize: "100% 100%",
                  bgPos: "center",
                  width: "100%",
                  height: "100%",
                },
              }}
            >
              <AbsoluteCenter top="15%">
                <Box
                  w="150px"
                  h="120px"
                  bgRepeat={"no-repeat"}
                  bgPosition="center"
                  bgImage={`url(${COMMON_WEB_PATH}/theOne/gameType/footer_${item.label}.png)`}
                  bgSize="contain"
                  transition={"transform 0.3s ease-in-out"}
                  _groupHover={{
                    transform: "scale(1.1)",
                  }}
                />
              </AbsoluteCenter>
              <Text
                fontWeight={"400"}
                fontSize="24px"
                textShadow={"0 0 1.5px white"}
              >
                {i18n(item.label)}
              </Text>
            </GridItem>
          );
        })}
      </Grid>
      <Box w="30%" position="relative">
        <FireworksRight sx={{ right: "-3rem", bottom: "0" }} />
        <AbsoluteCenter role="group" as={NavLink} to={"/"} top="15%">
          <Box
            w="350px"
            h="200px"
            bgRepeat={"no-repeat"}
            bgPosition="center"
            bgImage={`url(${COMMON_WEB_PATH}/theOne/gameType/footer_LOBBY.png)`}
            bgSize="contain"
            transition={"transform 0.3s ease-in-out"}
            _groupHover={{
              transform: "scale(1.1)",
            }}
            position="relative"
          >
            <AbsoluteCenter top="82%">
              <Text
                fontWeight={"400"}
                fontSize="24px"
                textShadow={"0 0 1.5px white"}
              >
                {i18n("Home")}
              </Text>
            </AbsoluteCenter>
          </Box>
        </AbsoluteCenter>
      </Box>
      <Grid pb="20px" pr="50px" w="40%" templateColumns={`repeat(3, 1fr)`}>
        {rightMenu.map((item, index) => {
          return (
            <GridItem
              role="group"
              alignItems={"center"}
              justifyContent={"flex-end"}
              display="flex"
              flexDirection={"column"}
              gap="10px"
              position="relative"
              cursor="pointer"
              as={NavLink}
              to={item.link}
              _hover={{
                _after: {
                  content: "''",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                  bgImage: `url(${COMMON_WEB_PATH}/theOne/footer/footer_menu_active.png)`,
                  bgSize: "100% 100%",
                  bgPos: "center",
                  width: "100%",
                  height: "100%",
                },
              }}
            >
              <AbsoluteCenter top="15%">
                <Box
                  w="150px"
                  h="120px"
                  bgRepeat={"no-repeat"}
                  bgPosition="center"
                  bgImage={`url(${COMMON_WEB_PATH}/theOne/gameType/footer_${item.label}.png)`}
                  bgSize="contain"
                  transition={"transform 0.3s ease-in-out"}
                  _groupHover={{
                    transform: "scale(1.1)",
                  }}
                />
              </AbsoluteCenter>
              <Text
                fontWeight={"400"}
                fontSize="24px"
                textShadow={"0 0 1.5px white"}
              >
                {i18n(item.label)}
              </Text>
            </GridItem>
          );
        })}
      </Grid>
    </Box>
  );
};

export default MachineFooter;
